<script setup lang="ts">
import LeBell from "@dsk/icons/LeBell.vue";
import { useI18n } from "vue-i18n";
import { useToast } from "vue-toastification";

import LeUncaughtErrorToast from "./toasts/LeUncaughtErrorToast.vue";

const toast = useToast();
const i18n = useI18n();

window.addEventListener("unhandledrejection", () => {
  // Clear previous toasts to force show error message.
  toast.clear();

  toast.error(
    {
      component: LeUncaughtErrorToast,
      props: {
        i18n
      }
    },
    { timeout: 10000, icon: LeBell }
  );
});
</script>

<template>
  <slot></slot>
</template>
